/* eslint-disable no-underscore-dangle */
import React from 'react';
import styled from 'styled-components';

import SEO from '../components/SEO';
import SiteLogo from '../components/SiteLogo';

const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const Content = styled.div`
  max-width: 600px;
  width: 100%;
  padding: 2rem;
`;

const Text = styled.div`
  padding: 2rem;
`;

function App() {
  return (
    <Container>
      <SEO title="Coming soon" />

      <Content>
        <SiteLogo />
        <Text>Coming soon</Text>
      </Content>
    </Container>
  );
}
export default App;
